import { render, staticRenderFns } from "./SBSRfiWidget.vue?vue&type=template&id=11c7a00e"
import script from "./SBSRfiWidget.vue?vue&type=script&lang=js"
export * from "./SBSRfiWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports